import React, { useContext } from 'react';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { func, string, number, array } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { Box } from '@material-ui/core';
import SpiceIcons from '../../SpiceIcons';
import AppContext from '~contexts/AppContext';
import AllergyDesc from '../../AllergyDesc';

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: '100%', // Ensures the popup respects width
    overflow: 'hidden', // Prevents horizontal scrolling
    padding: `${theme.spacing(1.5)}px ${theme.spacing(
      2
    )}px ${theme.spacing(2)}px`,
  },
  closeButton: {
    color: theme.palette.grey[500],
    marginBottom: theme.spacing(5),
    marginRight: '5px',
    padding: 0,
  },
  title: {
    display: 'inline-block',
  },
  subtitle: {
    display: 'block',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    maxWidth: '100%',
  }
}));

const ProductItemDialogTitle = ({
  title,
  subTitle,
  allergies,
  price,
  onClose,
  spiceLevel,
  ...other
}) => {
  const { formatPrice } = useContext(AppContext);
  const styles = useStyles();

  return (
    <MuiDialogTitle sx={{
      overflow: 'hidden',  // Prevents horizontal scrolling
    }} className={styles.root} disableTypography {...other}>
      {/* Top section with title and close button */}
      <Grid 
        container 
        justifyContent="space-between" 
        alignItems="center"
        sx={{ width: '100%', overflow: 'hidden' }}
      >
        {/* Title */}
        <Grid item xs>
          <Typography variant="h6" gutterBottom className={styles.title}>
            {title}
          </Typography>
          {spiceLevel ? <SpiceIcons spiceLevel={spiceLevel} /> : ""}
        </Grid>

        {/* Close Button */}
        <Grid item>
          <IconButton
            aria-label="close"
            className={styles.closeButton}
            onClick={onClose}
            size="small"
            sx={{
              flexShrink: 0, // Prevents shrinking
              marginLeft: "auto",
            }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>

      {/* Subtitle */}
      <Box sx={{ width: '100%', overflow: 'hidden' }}>
        <Typography
          variant="body2"
          gutterBottom
          className={styles.subtitle}
        >
          {subTitle}
        </Typography>
      </Box>

      {/* Allergies and Price Section */}
      <Grid 
        container 
        justifyContent="space-between" 
        alignItems="center" 
        sx={{ width: '100%', overflow: 'hidden' }}
      >
        {/* Allergies */}
        <Grid item xs>
          {allergies?.length > 0 && <AllergyDesc allergies={allergies} />}
        </Grid>

        {/* Price */}
        {price !== 0 && (
          <Typography
          className={styles.price}
              variant="body2"
              align="right"
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%',
                marginLeft: '20px',
                flexShrink: 0, // Ensures price doesn't shrink
              }}
            >
              <i>{formatPrice(price)}</i>
            </Typography>
        )}
      </Grid>
    </MuiDialogTitle>
  );
};


ProductItemDialogTitle.propTypes = {
  onClose: func.isRequired,
  title: string,
  subTitle: string,
  allergies: array,
  price: number,
  spiceLevel: number,
};

ProductItemDialogTitle.defaultProps = {
  title: '',
  subTitle: '',
  price: 0,
  allergies: [],
};

export default ProductItemDialogTitle;
